import React, { useEffect, useState } from "react";
import { authFetch } from "../../utils/authFetch";
import { Link } from "react-router-dom";
import "../UserProfile/style.css";

const UserProfile = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const username = storedUser?.username;

  const [user, setUser] = useState(null);
  const [watchHistory, setWatchHistory] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!username) {
      setError("Không tìm thấy thông tin người dùng trong localStorage.");
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      try {
        const userRes = await authFetch(
          `${baseUrl}/users/search?keyword=${username}`
        );
        const userData = await userRes.json();
        const currentUser = userData.content?.[0];

        if (!currentUser) {
          setError("Không tìm thấy người dùng phù hợp.");
          setLoading(false);
          return;
        }

        setUser(currentUser);

        const [watchRes, favRes] = await Promise.all([
          authFetch(`${baseUrl}/watch-history?userId=${currentUser.id}`),
          authFetch(`${baseUrl}/favorites/my?userId=${currentUser.id}`)
        ]);

        const watchData = await watchRes.json();
        const favData = await favRes.json();

        setWatchHistory(watchData);
        setFavorites(favData);
      } catch (err) {
        console.error(err);
        setError("Đã xảy ra lỗi khi tải dữ liệu cá nhân.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [username]);

  const handleEditProfile = () => {
    // Có thể mở modal hoặc redirect đến trang chỉnh sửa thông tin
    alert("Tính năng chỉnh sửa hồ sơ chưa được triển khai.");
  };

  if (loading) return <div className="loading">Đang tải...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="page-wrapper">
      <div className="user-profile container">
        <div className="user-profile container">
          <h2>Trang cá nhân</h2>

          <div className="user-info">
            <p><strong>Username:</strong> {user.username}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Họ tên:</strong> {user.fullName || "Chưa cập nhật"}</p>
            <button className="edit-button" onClick={handleEditProfile}>Chỉnh sửa hồ sơ</button>
          </div>

          <div className="section">
            <h3>Lịch sử xem phim</h3>
            {watchHistory.length === 0 ? (
              <p>Bạn chưa xem phim nào.</p>
            ) : (
              <ul className="movie-list">
                {watchHistory.map(item => (
                  <li key={item.id}>
                    <Link to={`/movies/${item.movieId}`} className="movie-link">
                      {item.movieTitle} — <span>{new Date(item.watchDate).toLocaleString()}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="section">
            <h3>Phim đã yêu thích</h3>
            {favorites.length === 0 ? (
              <p>Bạn chưa yêu thích phim nào.</p>
            ) : (
              <ul className="movie-list">
                {favorites.map(item => (
                  <li key={item.id}>
                    <Link to={`/movie/${item.movieId}`} className="movie-link">
                      {item.movieTitle}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
